import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainTransferDevice(params) {
  return maintainRequest({
    url: `/device/maintenanceMan/chargingPile/transferDevice`,
    method: "get",
    params,
  });
}
